import "./index.css";
import {ApolloLink as $hgUW1$ApolloLink, HttpLink as $hgUW1$HttpLink, concat as $hgUW1$concat, ApolloClient as $hgUW1$ApolloClient} from "@apollo/client";
import {AUTH_TYPE as $hgUW1$AUTH_TYPE, createAuthLink as $hgUW1$createAuthLink} from "aws-appsync-auth-link";
import {get as $hgUW1$get} from "js-cookie";
import {onError as $hgUW1$onError} from "@apollo/client/link/error";
import {RetryLink as $hgUW1$RetryLink} from "@apollo/client/link/retry";
import {setContext as $hgUW1$setContext, Replay as $hgUW1$Replay, init as $hgUW1$init, ErrorBoundary as $hgUW1$ErrorBoundary} from "@sentry/react";
import {Integrations as $hgUW1$Integrations} from "@sentry/tracing";
import {CaptureConsole as $hgUW1$CaptureConsole} from "@sentry/integrations";
import {TagManager as $hgUW1$TagManager} from "@mineko/react-gtm-promisified";
import {jsxs as $hgUW1$jsxs, jsx as $hgUW1$jsx} from "react/jsx-runtime";
import $hgUW1$react, {useContext as $hgUW1$useContext} from "react";
import $hgUW1$axios from "axios";
import $hgUW1$axiosretry from "axios-retry";
import $hgUW1$isretryallowed from "is-retry-allowed";

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $56a3d902aefbaef7$exports = {};
var $f48b1fd42b475868$exports = {};

$parcel$export($f48b1fd42b475868$exports, "initializeClient", () => $f48b1fd42b475868$export$299f86cb8e894b79);



var $fa7cf714a7f36a56$exports = {};

$parcel$export($fa7cf714a7f36a56$exports, "cleanTypenameLink", () => $fa7cf714a7f36a56$export$df1777e9719ef5a8);
$parcel$export($fa7cf714a7f36a56$exports, "errorLink", () => $fa7cf714a7f36a56$export$b5813bf6289ecad);
$parcel$export($fa7cf714a7f36a56$exports, "retryLink", () => $fa7cf714a7f36a56$export$a51db439a65b48ef);



const $fa7cf714a7f36a56$export$df1777e9719ef5a8 = new (0, $hgUW1$ApolloLink)((operation, forward)=>{
    const omitTypename = (key, value)=>key === "__typename" ? undefined : value;
    if (operation.variables && !operation.variables.file) operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
    return forward(operation);
});
const $fa7cf714a7f36a56$export$b5813bf6289ecad = (handleError)=>(0, $hgUW1$onError)(({ networkError: networkError , graphQLErrors: graphQLErrors  })=>{
        graphQLErrors && console.error("API Error: graphQLErrors", JSON.stringify(graphQLErrors));
        networkError && console.error("API Error: networkError", JSON.stringify(networkError));
        if (!handleError) return;
        if (networkError) {
            const error = networkError;
            if (error?.statusCode === 401) {
                handleError({
                    type: "AUTH_EXPIRED",
                    message: error.message,
                    payload: {
                        redirectUrl: error.result.error.redirectUrl
                    }
                });
                return;
            }
            handleError({
                type: "UNKNOWN_ERROR",
                message: error.message
            });
        }
        if (graphQLErrors) handleError({
            type: "UNKNOWN_ERROR",
            message: graphQLErrors[0].message
        });
    });
const $fa7cf714a7f36a56$export$a51db439a65b48ef = (retryCondition)=>new (0, $hgUW1$RetryLink)({
        delay: {
            initial: 300,
            max: Infinity,
            jitter: true
        },
        attempts: {
            max: 3,
            retryIf: (error, _operation)=>retryCondition ? retryCondition(error, _operation) : !!error.networkError
        }
    });


const $f48b1fd42b475868$var$baseAuthOptions = {
    type: (0, $hgUW1$AUTH_TYPE).NONE
};
const $f48b1fd42b475868$var$authMiddleware = (csrfCookieName)=>new (0, $hgUW1$ApolloLink)((operation, forward)=>{
        csrfCookieName && operation.setContext(({ headers: headers = {}  })=>({
                headers: {
                    ...headers,
                    "x-csrf": (0, $hgUW1$get)(csrfCookieName)
                }
            }));
        return forward(operation);
    });
const $f48b1fd42b475868$var$getEndpointLinks = (endpoints)=>{
    let link = null;
    endpoints.forEach((endpoint)=>{
        if (!endpoint.clientName) throw new Error("clientName is required for all endpoints");
        if (!endpoint.url) throw new Error("url is required for all endpoints");
        if (!link) link = new (0, $hgUW1$HttpLink)({
            uri: endpoint.url
        });
        const newLink = new (0, $hgUW1$HttpLink)({
            uri: endpoint.url
        });
        link = (0, $hgUW1$ApolloLink).split((operation)=>operation.getContext().clientName === endpoint.clientName, newLink, link);
    });
    if (!link) throw new Error("No link was created for the client. Make sure you're passing in endpoints");
    return link;
};
const $f48b1fd42b475868$export$299f86cb8e894b79 = ({ endpoints: endpoints , cache: cache , authOptions: authOptions = {} , region: region = "AWS_REGION" , links: links = [] , retryCondition: retryCondition , csrfCookieName: csrfCookieName  })=>{
    // use the primary endpoint as the default for auth link
    const firstEndpointUrl = endpoints[0].url;
    const config = {
        url: firstEndpointUrl,
        region: region,
        auth: {
            ...$f48b1fd42b475868$var$baseAuthOptions,
            ...authOptions
        }
    };
    const link = (0, $hgUW1$concat)($f48b1fd42b475868$var$authMiddleware(csrfCookieName), (0, $hgUW1$ApolloLink).from([
        (0, $hgUW1$createAuthLink)(config),
        ...links,
        (0, $fa7cf714a7f36a56$export$a51db439a65b48ef)(retryCondition),
        $f48b1fd42b475868$var$getEndpointLinks(endpoints)
    ]));
    return new (0, $hgUW1$ApolloClient)({
        link: link,
        cache: cache
    });
};



$parcel$exportWildcard($56a3d902aefbaef7$exports, $f48b1fd42b475868$exports);
$parcel$exportWildcard($56a3d902aefbaef7$exports, $fa7cf714a7f36a56$exports);


var $ab1d09b35ee4d28e$exports = {};
var $11e93fc0808db3ba$exports = {};

$parcel$export($11e93fc0808db3ba$exports, "SentrySetContext", () => $11e93fc0808db3ba$export$d1f20e18d63133cd);
$parcel$export($11e93fc0808db3ba$exports, "SentryInit", () => $11e93fc0808db3ba$export$dc1f4e41fb91cdb3);
$parcel$export($11e93fc0808db3ba$exports, "SentryErrorBoundary", () => $11e93fc0808db3ba$export$b69d0d92862de18b);



const $11e93fc0808db3ba$export$d1f20e18d63133cd = (name, context)=>{
    $hgUW1$setContext(name, context);
};
const $11e93fc0808db3ba$export$dc1f4e41fb91cdb3 = ({ dsn: dsn , release: release , environment: environment , integrations: integrations = []  })=>{
    const applyIntegrations = [
        new (0, $hgUW1$Integrations).BrowserTracing(),
        new (0, $hgUW1$CaptureConsole)({
            // array of methods that should be captured
            // defaults to ['log', 'info', 'warn', 'error', 'debug', 'assert']
            levels: [
                "error"
            ]
        })
    ];
    integrations?.includes("Replay") && applyIntegrations.push(new $hgUW1$Replay({
        maskAllText: true,
        blockAllMedia: true
    }));
    return $hgUW1$init({
        dsn: dsn,
        release: release,
        environment: environment,
        // since v6 of sentry there is an issue withg sessionTracking, so this needs to be disabled until they fix it
        // see https://github.com/getsentry/sentry-javascript/issues/3234
        autoSessionTracking: false,
        integrations: applyIntegrations,
        replaysOnErrorSampleRate: 1.0
    });
};
const $11e93fc0808db3ba$export$b69d0d92862de18b = $hgUW1$ErrorBoundary;


$parcel$exportWildcard($ab1d09b35ee4d28e$exports, $11e93fc0808db3ba$exports);


var $81968871348e6881$exports = {};
var $d178f8e5a140a4cb$exports = {};

$parcel$export($d178f8e5a140a4cb$exports, "GtmInit", () => $d178f8e5a140a4cb$export$f7901ac6728a4343);

const $d178f8e5a140a4cb$export$f7901ac6728a4343 = (0, $hgUW1$TagManager).init;


$parcel$exportWildcard($81968871348e6881$exports, $d178f8e5a140a4cb$exports);


var $ce6e67bebedf0d34$exports = {};
var $d4ce90cc32517378$exports = {};
var $61e8ef3140005bc0$exports = {};

$parcel$export($61e8ef3140005bc0$exports, "Logo", () => $61e8ef3140005bc0$export$e6ff31bff12b7ff4);



const $61e8ef3140005bc0$export$e6ff31bff12b7ff4 = ({ claim: claim = true , claimText: claimText = "Mietnebenkosten korrekt?" , height: height = 35 , width: width = 122 , title: title = "Nebenkostenabrechnung pr\xfcfen lassen bei MINEKO" , textColor: textColor = "#383839" , iconColor0: iconColor0 = "#6fbc4d" , iconColor1: iconColor1 = "#16a085" , onClick: onClick , className: className  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 854.7 255",
        version: "1",
        width: width,
        height: height,
        "aria-labelledby": title,
        className: className,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("title", {
                id: title,
                children: title
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("linearGradient", {
                id: "SVGID_1_",
                x1: "652.1",
                x2: "853.1",
                y1: "84.75",
                y2: "84.75",
                gradientUnits: "userSpaceOnUse",
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("stop", {
                        offset: "0",
                        stopColor: iconColor0
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("stop", {
                        offset: "1",
                        stopColor: iconColor1
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                fill: "url(#SVGID_1_)",
                d: "M652.1 78.8h29.4l28.6 33.6L826.3 3h26.8L705.7 166.5z"
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        fill: textColor,
                        d: "M673.5 130.1c-1.1 0-2.1.2-2.9.2-23.4 0-42.1-18.9-42.1-42.1 0-23.4 18.9-42.1 42.1-42.1 23.4 0 42.1 18.9 42.1 42.1 0 3.4-.4 6.5-1.1 9.7l29.5-27.8c-8-31.4-36.6-54.7-70.5-54.7C630.4 15.4 598 48 598 88c0 40.2 32.6 72.6 72.6 72.6 6.9 0 13.7-1.1 20.2-2.7l-17.3-27.8z"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        fill: textColor,
                        d: "M128 160c-2.1-54.7-3.4-91.8-3.4-111.3h-.6c-3.4 14.7-14.5 50.9-33.5 109H65.9c-11.4-40-18.1-64.6-20.4-73.7-2.3-9-4.8-20.8-7.8-35.4h-.4c-.8 27.6-1.7 47.4-2.3 59.6L32.3 160H2.8l8.8-137.9h42.9c10.5 35.1 16.8 57 19.2 65.2 2.1 8.4 4.2 18.3 6.5 29.9h.8c5.1-21.3 9.3-37.3 12.8-48l15.8-47.1h42.1l7.4 137.9H128zM181.7 22.2h31.8V160h-31.8V22.2zM267.8 160h-29.3V22.2h37.7l33.3 56.4c6.3 10.9 13 24.8 20 41.9h.4c-1.7-14.5-2.5-33.5-2.5-56.8V22.2h29.3V160h-33.5c-23.4-40.6-37.3-65-41.9-73.5-4.4-8.4-9.3-18.1-14.1-29.3h-.8c1.1 17.5 1.5 37.5 1.5 60l-.1 42.8zM462.4 76.5V102h-53v32.4h59.1V160h-90.7V22.2h87.8v25.7h-56.2v28.4h53v.2zM487.9 160V22.2h31.4V83c4.2-6.1 8-11.8 11.4-16.4l31.6-44.2h39.4l-47.1 58.5 49.9 79.3h-37l-35.6-59.8-12.2 14.7v45l-31.8-.1z"
                    })
                ]
            }),
            claim && /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("text", {
                    x: "0",
                    y: "241",
                    style: {
                        letterSpacing: "-1pt"
                    },
                    fontSize: 70,
                    fontFamily: "Meta",
                    fill: textColor,
                    children: claimText
                })
            })
        ]
    });


$parcel$exportWildcard($d4ce90cc32517378$exports, $61e8ef3140005bc0$exports);


$parcel$exportWildcard($ce6e67bebedf0d34$exports, $d4ce90cc32517378$exports);


var $78d5c0953e7bc63d$exports = {};
var $84b0b1bc83367e92$exports = {};

$parcel$export($84b0b1bc83367e92$exports, "FeatureTrackingContext", () => $84b0b1bc83367e92$export$1d2ebc028bffa5d1);
$parcel$export($84b0b1bc83367e92$exports, "useTrackFeature", () => $84b0b1bc83367e92$export$aee829cd601bef67);

const $84b0b1bc83367e92$export$1d2ebc028bffa5d1 = (0, $hgUW1$react).createContext(null);
const $84b0b1bc83367e92$export$aee829cd601bef67 = ()=>{
    const appName = (0, $hgUW1$useContext)($84b0b1bc83367e92$export$1d2ebc028bffa5d1);
    const handleTracking = (featureId, eventType, payload, entityId)=>{
        if (!appName) throw new Error("App name is missing, have you wrapped this component inside the FeatureTrackingContext.Provider?");
        try {
            fetch(`/capture-event`, {
                method: "POST",
                body: JSON.stringify({
                    featureId: featureId,
                    appName: appName,
                    timestamp: new Date().toISOString(),
                    eventType: eventType,
                    payload: payload,
                    ...entityId && {
                        entityId: entityId
                    }
                })
            });
        } catch (e) {
            console.error(e);
        }
    };
    return {
        track: handleTracking
    };
};


$parcel$exportWildcard($78d5c0953e7bc63d$exports, $84b0b1bc83367e92$exports);


var $992b42a5fa09e36f$exports = {};
var $2b4247042284824d$exports = {};

$parcel$export($2b4247042284824d$exports, "retryCondition", () => $2b4247042284824d$export$7bcc93217746b74e);
$parcel$export($2b4247042284824d$exports, "Axios", () => $2b4247042284824d$export$1c00760e9e5a4e95);



const $2b4247042284824d$export$7bcc93217746b74e = (error)=>error.isAxiosError && (0, $hgUW1$isretryallowed)(error);
const $2b4247042284824d$export$1c00760e9e5a4e95 = {
    setRetry: (retries)=>(0, $hgUW1$axiosretry)((0, $hgUW1$axios), {
            retryDelay: (0, $hgUW1$axiosretry).exponentialDelay,
            retries: retries ?? 8,
            retryCondition: $2b4247042284824d$export$7bcc93217746b74e
        })
};


$parcel$exportWildcard($992b42a5fa09e36f$exports, $2b4247042284824d$exports);




export {$f48b1fd42b475868$export$299f86cb8e894b79 as initializeClient, $fa7cf714a7f36a56$export$df1777e9719ef5a8 as cleanTypenameLink, $fa7cf714a7f36a56$export$b5813bf6289ecad as errorLink, $fa7cf714a7f36a56$export$a51db439a65b48ef as retryLink, $11e93fc0808db3ba$export$d1f20e18d63133cd as SentrySetContext, $11e93fc0808db3ba$export$dc1f4e41fb91cdb3 as SentryInit, $11e93fc0808db3ba$export$b69d0d92862de18b as SentryErrorBoundary, $d178f8e5a140a4cb$export$f7901ac6728a4343 as GtmInit, $61e8ef3140005bc0$export$e6ff31bff12b7ff4 as Logo, $84b0b1bc83367e92$export$1d2ebc028bffa5d1 as FeatureTrackingContext, $84b0b1bc83367e92$export$aee829cd601bef67 as useTrackFeature, $2b4247042284824d$export$7bcc93217746b74e as retryCondition, $2b4247042284824d$export$1c00760e9e5a4e95 as Axios};
//# sourceMappingURL=module.js.map
